import { v4 as uuidv4 } from 'uuid';

export function SocialNetwork(props) {
	return {
		componentName: 'SocialNetwork',
		componentId: uuidv4(),
		props: {
			...props,
		},
		childrenComponents: [],
	};
}
